import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ArmyBuilderConfig } from '../global/config';
import { HttpClientWithInFlightCache } from '../global/httpClient';
import { UserNotification } from './models';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    private config = inject(ArmyBuilderConfig);
    private http = inject(HttpClientWithInFlightCache);

    private get baseUrl() {
        return `${this.config.apiBaseUrl}/notifications`;
    }

    getNotifications(): Observable<UserNotification[]> {
        return this.http.get(this.baseUrl, { requiresLogin: true });
    }

    markRead(notificationId: string): Observable<void> {
        return this.http.patch(`${this.baseUrl}/${notificationId}/read`, {}, { requiresLogin: true });
    }
}
